"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as E, jsx as n } from "react/jsx-runtime";
import * as c from "react";
import m from "classnames";
import O from "./screen-reader-only.js";
import { notTouchable as _, touchable as j, base as B, marginReset as V } from "./touchable.css-mistica.js";
import { useTheme as L } from "./hooks.js";
import { isInsideNovumNativeApp as $ } from "./utils/platform.js";
import { ENTER as q, SPACE as z } from "./utils/keys.js";
import { getPrefixedDataAttributes as F } from "./utils/dom.js";
import { redirect as G } from "./utils/browser.js";
const R = /*#__PURE__*/ c.forwardRef((e, t)=>{
    var P;
    const { texts: o, analytics: C, platformOverrides: x, Link: I, useHrefDecorator: D } = L(), A = D(), u = c.useRef(!1);
    let l = [];
    e.trackingEvent && (Array.isArray(e.trackingEvent) ? l = e.trackingEvent : l = [
        e.trackingEvent
    ]);
    const d = e.children, i = _object_spread({
        className: e.className,
        disabled: e.disabled,
        style: e.style,
        role: e.role,
        "aria-checked": e["aria-checked"],
        "aria-disabled": e.disabled ? !0 : void 0,
        "aria-controls": e["aria-controls"],
        "aria-expanded": e["aria-expanded"],
        "aria-haspopup": e["aria-haspopup"],
        "aria-hidden": e["aria-hidden"],
        "aria-selected": e["aria-selected"],
        "aria-live": e["aria-live"],
        tabIndex: e.tabIndex
    }, F(e.dataAttributes, "Touchable")), s = e.type ? e.type : "button", r = !!e.newTab, H = (P = e.href) == null ? void 0 : P.startsWith("#"), h = !r && !!e.href && !!e.loadOnTop, b = (a)=>{
        e.stopPropagation && a.stopPropagation();
    }, g = (a)=>{
        e.onPress && e.onPress(a);
    }, y = ()=>{
        var _e_to_pathname;
        return e.href ? A(e.href) : e.to && e.fullPageOnWebView ? typeof e.to == "string" ? e.to : (_e_to_pathname = e.to.pathname) !== null && _e_to_pathname !== void 0 ? _e_to_pathname : "" : "";
    }, k = ()=>Promise.all(l.map((a)=>C.logEvent(a))), v = (a)=>{
        u.current || (u.current = !0, k().finally(()=>{
            u.current = !1, a();
        }));
    }, K = (a)=>{
        if (b(a), !l.length) {
            g(a);
            return;
        }
        v(()=>g(a));
    }, S = (a)=>{
        var w;
        b(a);
        const f = !!(e.href && e.onNavigate);
        !l.length && !f || (a.preventDefault(), Promise.resolve(f ? (w = e.onNavigate) == null ? void 0 : w.call(e) : void 0).finally(()=>{
            v(()=>G(y(), r, h));
        }));
    }, W = (a)=>{
        b(a), e.to && e.onNavigate && e.onNavigate(), k();
    }, N = (a)=>{
        (a.key === q || a.key === z) && (a.preventDefault(), a.currentTarget.click());
    }, T = ()=>r ? /* @__PURE__ */ n(O, {
            children: /* @__PURE__ */ n("span", {
                children: o.linkOpensInNewTab
            })
        }) : H ? /* @__PURE__ */ n(O, {
            children: /* @__PURE__ */ n("span", {
                children: o.linkOpensInCurrentPage
            })
        }) : null;
    if (e.href || e.to && e.fullPageOnWebView && $(x)) return /* @__PURE__ */ E("a", _object_spread_props(_object_spread({}, i), {
        "aria-label": e["aria-label"],
        "aria-labelledby": e["aria-labelledby"],
        onClick: S,
        onKeyDown: N,
        href: e.disabled ? void 0 : y(),
        target: (()=>{
            if (r) return "_blank";
            if (h) return "_top";
        })(),
        rel: r ? "noopener noreferrer" : void 0,
        ref: t,
        children: [
            d,
            T()
        ]
    }));
    if (e.to) return /* @__PURE__ */ E(I, _object_spread_props(_object_spread({}, i), {
        target: e.newTab ? "_blank" : void 0,
        "aria-label": e["aria-label"],
        "aria-labelledby": e["aria-labelledby"],
        innerRef: t,
        to: e.disabled ? "" : e.to,
        replace: e.replace,
        onClick: W,
        onKeyDown: N,
        children: [
            d,
            T()
        ]
    }));
    if (e.onPress) {
        var _e_as, _i_role;
        const a = (_e_as = e.as) !== null && _e_as !== void 0 ? _e_as : "button", f = (_i_role = i.role) !== null && _i_role !== void 0 ? _i_role : e.as === "a" ? "button" : void 0;
        return /*#__PURE__*/ c.createElement(a, _object_spread_props(_object_spread({}, i), {
            role: f,
            // this "form" attribute is useful when the form's submit button
            // is located outside the <form> element, for example if you use
            // a ButtonFixedFooter layout inside a form with the submit
            // button located at the footer, which is redered using a Portal
            form: s === "submit" && e.formId ? e.formId : void 0,
            "aria-label": e["aria-label"],
            "aria-labelledby": e["aria-labelledby"],
            type: s,
            ref: t,
            onClick: K,
            children: d
        }));
    }
    return /* @__PURE__ */ n("div", _object_spread_props(_object_spread({}, i), {
        ref: t,
        className: m(i.className, _),
        children: d
    }));
}), J = /*#__PURE__*/ c.forwardRef((e, t)=>/* @__PURE__ */ n(R, _object_spread_props(_object_spread({}, e), {
        className: m(j, e.className),
        ref: t
    }))), te = /*#__PURE__*/ c.forwardRef((_param, o)=>{
    var { resetMargin: e = !0 } = _param, t = _object_without_properties(_param, [
        "resetMargin"
    ]);
    return /* @__PURE__ */ n(R, _object_spread_props(_object_spread({}, t), {
        className: m(B, t.className, {
            [V]: e
        }),
        ref: o
    }));
}), ne = J;
export { te as BaseTouchable, ne as default };
